import { Action, ActionType } from "@redux/actionTypes/reportsActionTypes";
import { Reducer } from "react";

export interface IReportsDetailsState {
  reportsDetailsByPID: IReportsDetailsByPID[];
}

export interface IReportsDetailsByPID {
  projectId: number;
  projectName: string;
  projectType: string;
  status: string;
}
export interface TimelineDetails {
  initiatedDate: string;
  phasewiseDevelopment: Phase[];
}

export interface Phase {
  phaseHead: string;
  expectedDate: string;
  filingDT?: string;
}
const initialState = {
  reportsDetailsByPID: [],
};

export const reportsReducer: Reducer<IReportsDetailsState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.REPORTS_DETAILS_BY_PID:
      return {
        ...state,
        reportsDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
